module.exports = __webpack_public_path__ + "img/1492503371.1f086a2b.jpg";